import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { assignments } from '../../data/om-mig-data';
export function OmMigAssignments() {
  const [activeFilter, setActiveFilter] = useState('Alla');
  const filteredAssignments = activeFilter === 'Alla' ? assignments : assignments.filter(a => a.category === activeFilter);
  return <section className="py-16 md:py-24 px-6 bg-background" data-id="element-89">
      <div className="max-w-5xl mx-auto" data-id="element-90">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-12" data-id="element-91">
          <span className="text-terracotta font-medium tracking-widest text-xs uppercase mb-3 block" data-id="element-92">
            02 — Uppdrag i urval
          </span>
          <h2 className="text-3xl md:text-4xl font-light text-ink mb-8" data-id="element-93">
            Vad jag har gjort.{' '}
            <span className="text-muted" data-id="element-94">Utan att nämna namn.</span>
          </h2>

          {/* Filter Tabs */}
          <div className="flex flex-wrap gap-2 mb-10 border-b border-border/50 pb-4" data-id="element-95">
            {['Alla', 'Extern VD', 'Förändring', 'Utbildning', 'Rådgivning'].map(filter => <button key={filter} onClick={() => setActiveFilter(filter)} className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${activeFilter === filter ? 'text-ink bg-card' : 'text-muted hover:text-ink hover:bg-card/50'}`} data-id="element-96">
                {filter}
              </button>)}
          </div>

          {/* Assignments Grid */}
          <motion.div layout className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-97">
            <AnimatePresence data-id="element-98">
              {filteredAssignments.map(assignment => <motion.div layout key={assignment.id} initial={{
              opacity: 0,
              scale: 0.95
            }} animate={{
              opacity: 1,
              scale: 1
            }} exit={{
              opacity: 0,
              scale: 0.95
            }} transition={{
              duration: 0.3
            }} className="bg-card rounded-2xl p-6 border border-border/50 hover:border-border transition-colors" data-id="element-99">
                  <div className="flex justify-between items-start mb-4" data-id="element-100">
                    <span className={`text-xs font-medium tracking-widest uppercase px-2 py-1 rounded ${assignment.category === 'Extern VD' ? 'bg-terracotta/10 text-terracotta' : 'bg-sage/10 text-sage'}`} data-id="element-101">
                      {assignment.category}
                    </span>
                    <span className="text-xs text-muted font-mono" data-id="element-102">
                      {assignment.period}
                    </span>
                  </div>
                  <h3 className="text-lg font-medium text-ink mb-2" data-id="element-103">
                    {assignment.title}
                  </h3>
                  <p className="text-sm text-muted mb-6 leading-relaxed" data-id="element-104">
                    {assignment.description}
                  </p>
                  <div className="flex flex-wrap gap-2 mt-auto" data-id="element-105">
                    {assignment.tags.map(tag => <span key={tag} className="text-xs text-muted bg-background px-2 py-1 rounded border border-border/50" data-id="element-106">
                        {tag}
                      </span>)}
                  </div>
                </motion.div>)}
            </AnimatePresence>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}